import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
} from './club-logs.action';

import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecordsSuccess as fetchRecordsSuccessClub } from '../Clubs/clubs.action';
import { ClubLogsTableService } from './club-logs-table.service';
import { DatatableService } from 'src/app/core/services/datatable.service';


@Injectable()
export class ClubLogsRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap((data) => {
                const url = 'club/'+data.clubId+'/club-logs';
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {

                        const data = response.data;
                        const total = data.pagination.total;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page)

                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecordsSuccessClub({ listData: data.club, total: 0, isVatValid: false }));
                        return fetchRecordsSuccess({ listData: data.records, total: total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private moduleTableService: ClubLogsTableService,
        private tableService: DatatableService,
    ) { }

}